import * as api from '../../api'
import { jsError } from '../../common/utils'
import { buildAlertWithLocalizedMessages } from '../'

export const getPerson = (personId) => {
	return (dispatch) => {
		dispatch({ type: 'GET_PERSON_LOADING' })
		api
			.personGet(personId)
			.then((resp) => {
				dispatch(operationSucceeded(resp.data))
			})
			.catch((e) => {
				jsError(e)
				dispatch(operationFail())
				dispatch(
					buildAlertWithLocalizedMessages(
						'ERROR',
						'FetchPersonErrorAlertTitle',
						'Virhe henkilötietojen lukemisessa',
						e.response.data?.localizedMessages ? e.response.data.localizedMessages : null,
					),
				)
			})
	}
}

const operationSucceeded = (data) => ({
	type: 'GET_PERSON_SUCCEEDED',
	payload: { person: data },
})

const operationFail = () => ({
	type: 'GET_PERSON_FAIL',
})
